import Util from './Plaintext.Util';
import FocusManagement from './FocusManagement';

function init() {
  document.querySelectorAll('.findUs__dropdownLabel').forEach(label => {
    const dropdown = label.closest('.findUs__dropdown');
    const ddCl = dropdown.classList;
    
    // Slight delay here to avoid interfering with the body click-to-close listener below.
    label.addEventListener('click', () => {
      const isOpen = ddCl.contains('findUs__dropdown--open');
      
      window.setTimeout(() => {
        dropdown.querySelectorAll('.findUs__items').forEach(item => Util.prepDisplayNoneTransition(item, 'flex'));
        ddCl.toggle('findUs__dropdown--open', !isOpen);
      }, 0);
    });
  })
  
  FocusManagement.onEsc(() => {
    document.querySelectorAll('.findUs__dropdown').forEach(dd => dd.classList.remove('findUs__dropdown--open'));
  });

      
  document.body.addEventListener('click', () => {
    document.querySelectorAll('.findUs__dropdown').forEach(dd => {
      dd.querySelectorAll('.findUs__items').forEach(item => Util.prepDisplayNoneTransition(item, 'flex')); 
      dd.classList.remove('findUs__dropdown--open');
    });
  });
}

export default { init };